import uniq from 'lodash.uniq';
import { mutationTypes, actionTypes } from '@/types';
import { uiComponents, uiStates } from '@/tools/viewState';

export default {
	state: {
		activatedVUMarkIDs: [],
		proccedTo: null,
		warningHasBeenShown: false,
		showCoreKitNotSupportedWarning: false,
	},
	mutations: {
		[mutationTypes.augmentedRealitySetResult](state, result) {
			if (result.ActivatedVUMarkIDs) state.activatedVUMarkIDs = uniq(result.ActivatedVUMarkIDs);
		},
		[mutationTypes.augmentedRealitySetWarningScreenValues](state, { proccedTo }) {
			state.warningHasBeenShown = true;
			state.proccedTo = proccedTo;
		},
		[mutationTypes.arCoreKitSetWarningScreenValues](state, { showCoreKitNotSupportedWarning }) {
			state.showCoreKitNotSupportedWarning = showCoreKitNotSupportedWarning;
		},
	},
	actions: {
		[actionTypes.augmentedRealityShowWarning]({ commit }, { proccedTo }) {
			commit(mutationTypes.augmentedRealitySetWarningScreenValues, { proccedTo });
			commit(mutationTypes.viewStateSetUiState, [
				{ id: uiComponents.uiARWarning, uiState: uiStates.maximised },
			]);
		},
		[actionTypes.arCoreKitShowWarning]({ commit }, { showCoreKitNotSupportedWarning }) {
			commit(mutationTypes.arCoreKitSetWarningScreenValues, { showCoreKitNotSupportedWarning });
			commit(mutationTypes.viewStateSetUiState, [
				{ id: uiComponents.uiARCoreKitWarning, uiState: uiStates.maximised },
			]);
		},
	},
};
